import { Injectable } from '@angular/core';
import {
  Http,
  HttpModule,
  Headers,
  RequestOptions,
  Response,
} from '@angular/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PublicService {
  public ApiUrl = 'https://eye.shmu.ac.ir/api';
  public username = '';
  public password = '';
  public token = '';
  public logedIn = '';
  public firstName = '';
  public lastName = '';
  public newPass = '';
  public newPassRepeat = '';
  public APICalls: any = {};
  public Authorization = '';
  public user_basics:any = {};
  public user_info:any = {};
  /* Check-Out Variables ends */
  constructor(public http: Http, public router: Router) {
    this.token = localStorage.getItem('token');
    this.logedIn = localStorage.getItem('logedInVilla')!;
    if (this.logedIn == null) {
      this.logedIn = 'false';
    }
    this.user_basics = JSON.parse(localStorage.getItem('user_basics') || '{}');
    this.user_info = JSON.parse(localStorage.getItem('user_info') || '{}');
  }

  private extractData(res: Response, that: any) {
    console.log(res);
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }

    let body = res.json();
    if (body.message) {
    }
    console.log(body);
    if (body.alerts) {
      // that.DisplayErrorDialog(body.alerts);
      Promise.reject(body.alerts);
    } else {
      return body || {};
    }
  }
  private extractData2(res: Response) {
    if (res.status < 200 || res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    let body = res.json();
    return body || {};
  }
  private handleError(error: any) {
    // In a real world app, we might send the error to remote logging infrastructure
    let errMsg = JSON.parse(error._body).message; //error.message || 'Server error';
    console.error(errMsg); // log to console instead
    return Promise.reject(errMsg);
  }

  login(): Promise<any> {
    this.APICalls.login = true;

    let body = JSON.stringify({
      codemeli: this.username.toString(),
      password: this.password,
    });
    let headers = new Headers({
      'Content-Type': 'application/json',
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http
      .post(this.ApiUrl + '/login', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret
      .then((r) => {
        this.APICalls.login = false;
        // if (r.status == 'successful' && r.msg == 'not first') {
          if (r.status == 'success') {
          localStorage.setItem('token', r.token);
          localStorage.setItem('firstName', r.user.name);
          localStorage.setItem('lastName', r.user.famili);
          localStorage.setItem('user_basics', JSON.stringify(r.user));
          localStorage.setItem('user_info', JSON.stringify(r.user_info));
          this.token = localStorage.getItem('token');
          this.user_basics = r.user;
          this.user_info = r.user_info;
        }
        if (this.token != 'null' && this.token != null) {
          this.logedIn = 'true';
          localStorage.setItem('logedInVilla', 'true');
        }
      })
      .catch((e) => {
        this.APICalls.login = false;
      });
    return ret;
  }

  changePass(): Promise<any> {
    this.APICalls.changePass = true;
    let body = JSON.stringify({
      codemeli: this.username,
      password: this.password,
      newPassword: this.newPass,
    });
    let headers = new Headers({
      'Content-Type': 'application/json',
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http
      .post(this.ApiUrl + '/change-password', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret
      .then((r) => {
        this.APICalls.changePass = false;
      })
      .catch((e) => {
        this.APICalls.changePass = false;
      });
    return ret;
  }

  updateProfile(payload: any): Promise<any> {
    this.APICalls.updateProfile = true;
    let body = JSON.stringify(payload);
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.token,
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http
      .post(this.ApiUrl + '/change/profile', body, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret
      .then((r) => {
        this.APICalls.updateProfile = false;
      })
      .catch((e) => {
        this.APICalls.updateProfile = false;
      });
    return ret;
  }

  callingArray(): Promise<any> {
    this.APICalls.callingArray = true;
    let body = JSON.stringify({
      userid: this.token,
    });
    let headers = new Headers({
      // 'userid' : this.token,
      'Content-Type': 'application/json',
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http
      .get(this.ApiUrl + '/api/calling' + '?userid=' + this.token, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret
      .then((r) => {
        this.APICalls.callingArray = false;
      })
      .catch((e) => {
        this.APICalls.callingArray = false;
      });
    return ret;
  }

  checkStatus(): Promise<any> {
    this.APICalls.checkStatus = true;
    let body = JSON.stringify({
      userid: this.token,
    });
    let headers = new Headers({
      // 'userid' : this.token,
      'Content-Type': 'application/json',
    });
    let options = new RequestOptions({ headers: headers });
    let ret: Promise<any> = this.http
      .get(this.ApiUrl + '/api/user/check/checking' + '?userid=' + this.token, options)
      .toPromise()
      .then((r) => this.extractData(r, this))
      .catch(this.handleError);

    ret
      .then((r) => {
        this.APICalls.checkStatus = false;
      })
      .catch((e) => {
        this.APICalls.checkStatus = false;
      });
    return ret;
  }
}
